/*
 * @Author: knight
 * @Title:  a链接跳转失败
 * @Date: 2020-04-09 12:19:27
 * @Last Modified by: knight
 * @Last Modified time: 2020-04-27 12:15:42
 */
// import { SENTRY_INITIATIVE_MAIN_LABEL, sentryInitiativeReport } from '../utils/sentry';
// const logger = require('debug')('app:directive:href');

const href = {
    install(Vue) {
        this.setDirective(Vue);
    },

    setDirective(Vue) {
        const _this = this;
        Vue.directive('href', {
            bind(el) {
                el._handler = () => _this.onAdClick(el);
                el.addEventListener('click', el._handler, false);
            },
            unbind(el) {
                // logger('解绑了!');
                el.removeEventListener('click', el._handler);
            }
        });
    },

    onAdClick(el) {
        const hrefVal = el.getAttribute('href');
        const titleVal = el.getAttribute('title');

        // if (!hrefVal) {
        //     sentryInitiativeReport(SENTRY_INITIATIVE_MAIN_LABEL.href, '跳转异常', {
        //         title: titleVal,
        //         href: hrefVal
        //     });
        // }
    }
};

export default href;